<div class="col-12" *ngIf="config$ | async as config">
  <form class="login-form" [formGroup]="formGroup">
    <div class="title mb-0">
      <span class="text">{{ config?.productName }}</span>
    </div>

    <div *ngIf="loginError">
      <div class="alert alert-danger" data-test="login-alert">
        {{ 'auth.2fa.sign-in.error' | translate }}
      </div>
    </div>

    <div class="subtitle">
      <span class="text">{{ 'auth.2fa.' + controlMethod.value + '.login.subtitle' | translate }}</span>
    </div>

    <div class="mb-4 mx-auto mx-md-0">
      <cap-input-code formControlName="key"></cap-input-code>
    </div>

    <div class="login-actions d-flex align-items-center">
      <cap-button [label]="'auth.sign-in.button' | translate"
                  [disabled]="formGroup?.invalid"
                  [class.disabled]="formGroup?.invalid"
                  type="button"
                  styleClass="primary"
                  [attr.data-test]="'login-button'"
                  (click)="onSubmit()">
      </cap-button>

      <span class="login-separator">{{ 'auth.sign-in.or-label' | translate }}</span>

      <a routerLink="/auth/login" class="login-link" data-test="forgot-password-link">
        {{ 'auth.2fa.button.back-main-page' | translate }}
      </a>
    </div>
  </form>
</div>
